module.exports = __webpack_public_path__ + "static/drones-category-e5f95835db803172c1e7faf972a617fa.png";